// extracted by mini-css-extract-plugin
module.exports = {"container":"ThirdPartyIframe_container__2QnD-"};